import React, { ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';

import { useDropdownContext } from '../../dropdown/context/DropdownContext';
import { useLoadingBlur } from '../hooks/useLoadingBlur';
import { useOptionsTheme } from '../hooks/useOptionsTheme';
import { usePositionPlacement } from '../hooks/usePositionPlacement';

import cn from '../Options.module.scss';

export const OptionsCalendar = ({ children }: { children: ReactNode }) => {
  const { fieldRef, optionsRef, is_open, loading } = useDropdownContext();

  const [is_visible, setVisible] = useState(false);

  useEffect(() => {
    let timer: number;
    if (is_open) {
      timer = requestAnimationFrame(() => {
        setVisible(true);
      });
    } else {
      setVisible(false);
    }

    return () => {
      if (timer) cancelAnimationFrame(timer);
    };
  }, [is_open]);

  const { blur } = useLoadingBlur({ loading });
  const { theme } = useDropdownContext();

  const { border, background } = useFieldTheme();
  const { general, settings } = useOptionsTheme(theme?.options);

  const position = usePositionPlacement({
    fieldRef,
    optionsRef,
    container_height: 306,
    fit_content: true,
    is_open,
  });

  if (!is_open) return null;

  const content = (
    <div
      ref={optionsRef}
      className={classNames(cn.options, { [cn.visible]: is_visible })}
      onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
      style={{
        fontFamily: general.font_family,
        fontSize: general.font_size,
        padding: settings.padding,
        borderRadius: general.border_radius,
        background: background.normal,
        border: border.normal,
        height: 'fit-content',
        ...position,
      }}
    >
      <div className={classNames({ [cn.blur]: blur })}>{children}</div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};
